/**
 * isLocal
 * @returns boolean
 */
const isLocal = (): boolean => {
  if (import.meta.env.VITE_APP_MODE === 'local') {
    return true;
  }
  return false;
};

/**
 * isDev
 * @returns boolean
 */
const isDev = (): boolean => {
  if (import.meta.env.VITE_APP_MODE === 'development') {
    return true;
  }
  return false;
};

/**
 * domain
 * @returns string
 */
const domain = (): string => {
  const url =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
  return url;
};

export default {
  isLocal,
  isDev,
  /**
   * isProduction
   * @returns boolean
   */
  isProduction(): boolean {
    if (import.meta.env.VITE_APP_MODE === 'production') {
      return true;
    }
    return false;
  },
  /**
   * serverDomain
   * @returns string
   */
  serverDomain(): string {
    const fullPath =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
    let url = import.meta.env.VITE_APP_API_DOMAIN;
    if (!url) {
      url = fullPath;
    }
    return url;
  },
  /**
   * websiteDomain
   * @returns string
   */
  websiteDomain(): string {
    const fullPath =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
    let url = import.meta.env.VITE_APP_WEB_DOMAIN;
    if (!url) {
      url = fullPath;
    }
    return url;
  },
  domain,
  /**
   * baseURL
   * @returns void
   */
  baseURL(): string {
    if (this.isDev()) {
      return '';
    } else {
      return '/editor';
    }
  },
  getEmbedAppId(): string {
    return import.meta.env.VITE_GEMPAGES_APP_ID || '';
  },
  /**
   * __DOMAIN_UPLOAD
   * @returns string
   */
  __DOMAIN_UPLOAD: function (): string {
    return jQuery('body').attr('data-upload-domain') || 'https://media.gempages.net';
  },
  __INSTAGRAM: {
    __CLIENT_ID: import.meta.env.VITE_APP_INSTAGRAM_CLIENT_ID,
    __REDIRECT_URL: import.meta.env.VITE_APP_INSTAGRAM_REDIRECT_URL,
  },
};
